import { useCallback } from 'react';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';
import {
  NotificationsEventLabels,
  NotificationsEventsMap,
  type TrackNotificationsEvent,
} from './events';

/**
 * Custom hook to handle home page tracking events
 */
export function useTrackNotificationsAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackNotificationsEvent, extra?: Record<string, unknown>) => {
      const eventLabel = NotificationsEventLabels[event];
      const eventInfo = NotificationsEventsMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
